import { uniqueId } from 'onyx-common/lodash'

export default uniqueId
